<link rel="stylesheet" href="https://unpkg.com/swiper/css/swiper.css">
<link rel="stylesheet" href="https://unpkg.com/swiper/css/swiper.min.css">

<div class="index-slide ">
    <div  class="swiper-container height-100" [swiper]="config" >
        <div class="swiper-wrapper height-100">
          <div class="swiper-slide" *ngFor="let slide of slides" style="width: 1380px;">
            <div class="swiper-slide-image"
            [style.background-image]="'url(' + slide.image + ')'" >
              <div class="transparent-black"></div>
              <div fxLayout="column" class="swiper-slide-content" fxLayoutAlign="center center" fxLayoutGap="px">
                <h1 class="swiper-slide-title">{{slide.title}}</h1>
                <p class="swiper-slide-description">{{slide.description}}</p>
                <a href="{{slide.link}}" target="_blank" rel="noopener noreferrer">
                  <button mat-raised-button class="swiper-slide-button" *ngIf="slide.link != ''">{{slide.linkText}}</button>
                </a>
              </div>
            </div>
          </div>
        </div>
       
        <div class="swiper-scrollbar"></div>
        <div class="swiper-pagination"></div>
       
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
</div>
